// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__Ic2T3","text":"style_text__2EwVl","buttonContainer":"style_buttonContainer__3uIi8"};